<template>
  <div>
    <div class="vx-row flex flex-col">
      <div class="vx-col w-full">
        <vs-card>
          <div slot="header">
            <h3>Tambah Tanggal Libur</h3>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col w-full">
              <vx-input-group class="" prependClasses="border border-solid border-grey border-r-0 text-primary">
                <template slot="prepend">
                  <div class="prepend-text text-dark">
                    <span>
                      <vs-icon icon-pack="feather" icon="icon-calendar" />
                    </span>
                  </div>
                </template>
                <datepicker v-model="date" :format="'yyyy-MM-dd'" placeholder="Pilih Tanggal" />
              </vx-input-group>
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col w-full">
              <vs-input
                type="text"
                icon-after="true"
                icon-pack="feather"
                icon="icon-user"
                placeholder="Deskripsi Libur"
                class="w-full"
                v-model="description"
              />
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-row w-full">
              <div class="flex flex-row">
                <vs-button
                  @click="saveData"
                  class="ml-8 w-1/2"
                  color="primary"
                  icon-pack="feather"
                  icon="icon-send"
                  type="filled"
                >Simpan</vs-button>
                <vs-button
                  @click="$router.push({name: 'disable-date'})"
                  class="ml-3 w-1/2"
                  color="primary"
                  icon-pack="feather"
                  icon="icon-arrow-left"
                  type="border"
                >Kembali</vs-button>
              </div>
            </div>
          </div>
        </vs-card>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from "vue-select";
import Datepicker from "vuejs-datepicker";
import moment from 'moment';

export default {
  data() {
    return {
      date : '',
      description : '',
    };
  },
  methods: {
    saveData() {
      this.$vs.loading();
      this.$http
        .post(`/app/secure/disable-date/store`, {
          date : moment(this.date).format('YYYY-MM-DD'),
          description : this.description,
        })
        .then(() => {
          this.$vs.notify({
            title: "Sukses",
            text: "Berhasil menyimpan data libur.",
            color: "success",
            position: "top-right"
          });
          this.$router.push({name: 'disable-date'})
        })
        .catch(e => {
          this.parseError(e);
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    }
  },
  components: {
    "v-select": vSelect,
    Datepicker
  }
};
</script>